import useApi from "./useApi";

export default function useVerifyOtp() {
  const { post } = useApi();
  // This returns a mutation for /verify-otp
  return post("/verify-otp");
} 